import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
};

const agentHoldStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentHoldSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const agentHoldFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_HOLD_START:
      return agentHoldStart(state, action);
    case actionTypes.AGENT_HOLD_SUCCESS:
      return agentHoldSuccess(state, action);
    case actionTypes.AGENT_HOLD_FAIL:
      return agentHoldFail(state, action);
    default:
      return state;
  }
};

export default reducer;
